export default __webpack_public_path__ + "static/media/service-maintenance.d198b9e8.png";